export const DEFAULT_VISIBLE_FACET_VALUES = 5;
export const FACET_VALUE_FILTER_THRESHOLD = 10;

export type FacetValuesVisibility<T> = {
    visible: T[];
    exceedsLimit: boolean;
};

export const sliceVisibleFacetValues = <T>(
    values: T[],
    showAll: boolean,
    limit: number = DEFAULT_VISIBLE_FACET_VALUES,
): FacetValuesVisibility<T> => {
    const exceedsLimit = values.length > limit;
    const visible = showAll || !exceedsLimit ? values : values.slice(0, limit);

    return { visible, exceedsLimit };
};
